import _ from 'lodash';
import async from 'async';
import moment from 'moment';
import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import CheckIcon from '@material-ui/icons/CheckCircle';

import FMPTextField from '../../components/ui/FMPTextField';
import BulkDeliveryBatchContainer from '../../containers/logistics/BulkDeliveryBatch';
import ActivatingDeliveryDialog from '../../components/Dialogs/ConfirmingDialog';
import BulkDeliveryContainer from '../../containers/logistics/BulkDelivery';
import { getHtml } from './helpers';

const styles = (theme) => {
	return {
		note: {
			backgroundColor: '#D8F0FF',
			padding: 20,
			fontSize: 16,
			lineHeight: 1.4,
			marginBottom: 10,
			marginTop: 10,
			border: '1px solid #BADEFB',
		},
		lastChange: {
			//border: '2px solid #bbb',
			//backgroundColor: '#f1f1f1',
			backgroundColor: '#D8F0FF',
			border: '1px solid #BADEFB',
			borderRadius: 4,
			padding: 20,
			fontSize: 16,
			lineHeight: 1.4,
			marginBottom: 10,
			marginTop: 20,
		},
		sectionHeader: {
			margin: '30px 0px 10px 0px',
			textAlign: 'left',
			textTransform: 'uppercase',
			fontSize: 14,
			color: '#777',
			fontWeight: 900,
			letterSpacing: 2,
		},
		paper: {
			width: '100%',
			overflowX: 'auto',
			textAlign: 'left',
			boxSizing: 'border-box',
			padding: 20,
			[theme.breakpoints.up('md')]: {
				padding: '20px 30px 30px 30px',
			},
		},
		submitButton: {
			fontSize: 18,
			borderRadius: '100px',
			padding: '20px 30px',
			textTransform: 'uppercase',
		},
		orderDetails: {
			paddingTop: 40,
			fontSize: 24,
			fontWeight: 300,
			borderBottom: '1px solid #ddd',
		},
		infoSection: {
			paddingTop: 20,
			lineHeight: 1.4,
		},
		check: {
			color: '#4CAF50',
			width: 40,
			height: 40,
			verticalAlign: 'middle',
			paddingRight: 5,
		},
		confirmedTitle: {
			fontSize: 24,
			fontWeight: 500,
			padding: 20,
		},
		confirmedMessage: {
			padding: 20,
			lineHeight: 1.4,
			fontSize: 16,
		},
		deliveryId: {
			fontSize: 20,
			fontWeight: 200,
			color: '#444',
		},
	};
};
const formFields = {
	carrierConfirmationConfirmedBy: '',
};

class BulkCarrierConfirmation extends Component {
	constructor(props) {
		super(props);
		const bulkDeliveryBatchId = _.get(this.props, ['match', 'params', 'bulkDeliveryBatchId']);
		const bulkDeliveryId = _.get(this.props, ['match', 'params', 'bulkDeliveryId']);
		const securityHash = _.get(this.props, ['match', 'params', 'securityHash']);

		this.state = {
			bulkDeliveryBatchId: bulkDeliveryBatchId ? parseInt(bulkDeliveryBatchId, 10) : undefined,
			bulkDeliveryId: bulkDeliveryId ? parseInt(bulkDeliveryId, 10) : undefined,
			securityHash,
			errors: [],
			infoSection: undefined,
			formFieldError: {},
			isActiveDialogOpen: false,
			activatingStatus: 'pending',
		};
		this.state = _.merge(this.state, formFields);
	}

	componentDidMount() {
		getHtml({
			props: this.props,
			state: this.state,
			callback: (newState) => {
				this.setState(newState);
			},
		});
	}

	handleConfirm = () => {
		const { showErrors, carrierConfirmBulkDelivery, carrierConfirmBulkDeliveryBatch } = this.props;
		const { bulkDeliveryBatchId, bulkDeliveryId, securityHash } = this.state;

		const requiredFields = [{ display: 'Confirm By', fieldName: 'carrierConfirmationConfirmedBy' }];

		//- Required fields
		const formFieldError = {};
		const errors = [];
		requiredFields.forEach((s) => {
			if (!this.state[s.fieldName]) {
				formFieldError[s.fieldName] = `${s.display} is required`;
				errors.push(`${s.display} is required`);
			}
		});

		if (_.keys(formFieldError).length) {
			this.setState({ formFieldError });
			showErrors(errors);
			return;
		}

		const { carrierConfirmationConfirmedBy } = this.state;

		this.setState({
			isActiveDialogOpen: true,
			activatingStatus: 'activating',
		});

		setTimeout(() => {
			async.waterfall(
				[
					(callback) => {
						if (bulkDeliveryBatchId) {
							carrierConfirmBulkDeliveryBatch({
								params: {
									bulkDeliveryBatchId,
									securityHash,
									carrierConfirmationConfirmedBy,
								},
								callback,
							});
						} else {
							carrierConfirmBulkDelivery({
								params: {
									bulkDeliveryId,
									securityHash,
									carrierConfirmationConfirmedBy,
								},
								callback,
							});
						}
					},
				],
				(err, r) => {
					const newState = { activatingStatus: 'done' };
					if (err) {
						newState.errors = [err];
						return this.setState(newState);
					}

					const emailHtml = _.get(r, ['emailHtml']);
					if (emailHtml) {
						newState.emailHtml = emailHtml;
					} else {
						newState.errors = ['Missing info section'];
					}

					return this.setState(newState);
				}
			);
		}, 1000);
	};

	closeActivatingDialog = () => {
		this.setState({ isActiveDialogOpen: false });
	};

	onChange = (event, fieldName, index, attr) => {
		if (!_.isNumber(index)) {
			this.setState({ [fieldName]: event.target.value });
		} else {
			const inputs = this.state[fieldName].slice();
			if (attr) {
				inputs[index][attr] = event.target.value;
			} else {
				inputs[index] = event.target.value;
			}
			this.setState({ [fieldName]: inputs });
		}
	};

	render() {
		const { classes, bulkDeliveryBatch, bulkDeliveryMap, carrierMap } = this.props;
		let bulkDelivery = this.props.bulkDelivery;

		const { errors, emailHtml, isActiveDialogOpen, activatingStatus } = this.state;

		if (errors.length) {
			return (
				<div>
					<div>Encountered an error when retrieving the order</div>
					{errors.map((error, i) => {
						return <div key={i}>{error}</div>;
					})}
					;
				</div>
			);
		}

		if (!bulkDeliveryBatch && !bulkDelivery) {
			return <div>Fetching delivery information...</div>;
		}
		if (!emailHtml) {
			return <div>Fetching delivery details...</div>;
		}

		if (bulkDeliveryBatch) {
			const { bulkDeliveryIds } = bulkDeliveryBatch;
			const bulkDeliveryId = _.first(bulkDeliveryIds);
			bulkDelivery = bulkDeliveryMap[bulkDeliveryId];
			if (!bulkDelivery) {
				return <div>BulkDelivery not found:{bulkDeliveryId} not found in the system</div>;
			}
		}

		const {
			bulkDeliveryId,
			carrierId,
			isCancelled,
			cancellationReason,
			lastChanges = [],
		} = bulkDelivery;
		const carrier = carrierMap[carrierId];
		if (!carrier) {
			return <div>CarrierId:{carrierId} not found in the system</div>;
		}

		//- First time Batch confirmation
		let title = 'Bulk Delivery Confirmation';
		let type = 'bulk delivery request';
		let buttonText = 'Confirm All Deliveries';
		let hasChanges = false;
		let showBulkDeliveryId = false;

		//- Change
		if (!bulkDeliveryBatch) {
			title = `Bulk Delivery Change`;
			type = 'bulk delivery change';
			buttonText = 'Confirm Delivery Changes';
			hasChanges = true;
			showBulkDeliveryId = true;
		}

		//- Cancelled
		if (isCancelled) {
			title = `Bulk Cancellation Confirmation`;
			type = 'delivery cancellation';
			buttonText = 'Confirm Delivery Cancellation';
			hasChanges = false;
			showBulkDeliveryId = true;
		}

		const { carrierConfirmationConfirmedBy } = bulkDelivery;
		return (
			<Grid container spacing={3}>
				<Grid item xs={12}>
					<Grid container spacing={3}>
						<Grid item xs={12}>
							<Typography variant="h5" align="left" gutterBottom>
								{title}
							</Typography>
						</Grid>
					</Grid>
					<Paper className={classes.paper}>
						{showBulkDeliveryId && (
							<span className={classes.deliveryId}>
								Pearson Fuels Bulk Delivery Id : {bulkDeliveryId}
							</span>
						)}

						<div className={classes.note}>
							This {type} is intended for <strong>{carrier.name}</strong>. If you have received this
							order in error please contact{' '}
							<a href="mailto:dispatch@pearsonfuels.com">dispatch@pearsonfuels.com</a> or call
							833-385-3835.
							<br />
							<br />
							If you are <strong>{carrier.name}</strong>, please fill out the following information
							and click {buttonText}.
						</div>

						{hasChanges && (
							<div className={classes.lastChange}>
								<ul style={{ padding: 10, margin: 0 }}>
									{lastChanges.map((change, i) => {
										return <li key={i}>{change.display}</li>;
									})}
								</ul>
								<br />
								<div>Please see below for the full details of the order.</div>
							</div>
						)}

						{isCancelled && (
							<div className={classes.lastChange}>
								<strong>
									<span role="img" aria-label="cancel">
										🚫
									</span>{' '}
									Cancellation Reason
								</strong>
								<br />
								{cancellationReason}
								<br />
								<div>Please see below for the full details of the order.</div>
							</div>
						)}

						{!carrierConfirmationConfirmedBy &&
							this.renderForm({
								buttonText,
							})}
						{carrierConfirmationConfirmedBy &&
							this.renderConfirmed({
								bulkDelivery,
							})}

						<div className={classes.infoSection}>
							<div dangerouslySetInnerHTML={{ __html: emailHtml }} />
						</div>
					</Paper>

					<ActivatingDeliveryDialog
						open={isActiveDialogOpen}
						onClose={this.closeActivatingDialog}
						status={activatingStatus}
					/>
				</Grid>
			</Grid>
		);
	}

	renderForm({ buttonText }) {
		const { classes } = this.props;
		return (
			<div>
				<FMPTextField
					name={'carrierConfirmationConfirmedBy'}
					label={`Name of individual confirming`}
					controller={this}
					helpText={'required'}
				/>

				<div style={{ paddingTop: 40 }}>
					<Button
						variant="contained"
						color="primary"
						className={classes.submitButton}
						onClick={this.handleConfirm}
					>
						{buttonText}
					</Button>
				</div>
			</div>
		);
	}

	renderConfirmed({ bulkDelivery }) {
		const { classes } = this.props;
		const {
			carrierConfirmationConfirmedBy,
			carrierConfirmationConfirmedDateTime,
			isCancelled,
		} = bulkDelivery;

		const dateConfirmedFormatted = moment(carrierConfirmationConfirmedDateTime).format(
			'dddd, MMMM Do, YYYY [at] h:mm a'
		);

		const type = isCancelled ? 'cancellation' : 'delivery';
		return (
			<div>
				<div className={classes.confirmedTitle}>
					<CheckIcon className={classes.check} />
					This {type} request has been successfully submitted
				</div>
				<div className={classes.confirmedMessage}>
					Confirmation was submitted by <strong>{carrierConfirmationConfirmedBy}</strong> on{' '}
					{dateConfirmedFormatted}.
				</div>
			</div>
		);
	}
}

BulkCarrierConfirmation.propTypes = {
	classes: PropTypes.object.isRequired,
	showErrors: PropTypes.func,

	//- Batch
	carrierConfirmBulkDeliveryBatch: PropTypes.func,
	publicGetBulkDeliveryBatch: PropTypes.func,
	bulkDeliveryBatch: PropTypes.object,

	//- Single
	carrierConfirmBulkDelivery: PropTypes.func,
	publicGetBulkDelivery: PropTypes.func,
	bulkDelivery: PropTypes.object,

	supplierMap: PropTypes.object,
	carrierMap: PropTypes.object,
	bulkDeliveryMap: PropTypes.object,
};

export default _.flow([withStyles(styles), BulkDeliveryContainer, BulkDeliveryBatchContainer])(
	BulkCarrierConfirmation
);
